import { cn } from '@/lib/utils'
import type { ShadowPracticeData } from '@/hooks/useVisualTools'

interface ShadowPracticeCardProps {
  data: ShadowPracticeData
  onClose: () => void
  className?: string
}

export function ShadowPracticeCard({ data, onClose, className }: ShadowPracticeCardProps) {
  return (
    <div
      className={cn(
        'rounded-xl border p-5 shadow-lg animate-fade-in',
        'bg-gradient-to-br from-teal-50 to-cyan-50',
        'border-border',
        className
      )}
    >
      {/* Header with icon and close button */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="text-teal-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 6v12" />
              <path d="M17.196 9 6.804 15" />
              <path d="m6.804 9 10.392 6" />
            </svg>
          </span>
          <span className="text-sm font-semibold text-teal-700">
            Repeat after me
          </span>
        </div>
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground transition-colors p-1 rounded-full hover:bg-black/5"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>

      {/* Main sentence */}
      <p className="text-xl font-semibold text-foreground leading-relaxed">
        {data.sentence}
      </p>

      {/* Translation */}
      {data.translation && (
        <p className="mt-3 text-sm text-muted-foreground">
          ({data.translation})
        </p>
      )}

      {/* Animated microphone hint */}
      <div className="mt-4 flex items-center gap-2 text-xs text-teal-600">
        <span className="w-2 h-2 rounded-full bg-teal-500 animate-pulse" />
        <span>Your turn to speak</span>
      </div>
    </div>
  )
}
